export default __webpack_public_path__ + "static/media/drone-svg.1cdd3fea.svg";